import { StoryNode } from "./StoryNode";
import { StoryEdge } from "./StoryEdge";
export class StoryEventObject {
    static create(elements) {
        return new StoryEventObject(elements);
    }
    constructor(elements) {
        this.elements = elements;
        this.naming = "StoryEventObject";
    }
    static asNode(element) {
        if (element instanceof StoryNode) {
            return element;
        }
        return undefined;
    }
    static asEdge(element) {
        if (element instanceof StoryEdge) {
            return element;
        }
        return undefined;
    }
}
